import { render, staticRenderFns } from "./deleteExamineProject.vue?vue&type=template&id=6289a5c8&scoped=true"
import script from "./deleteExamineProject.vue?vue&type=script&lang=js"
export * from "./deleteExamineProject.vue?vue&type=script&lang=js"
import style0 from "./deleteExamineProject.vue?vue&type=style&index=0&id=6289a5c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6289a5c8",
  null
  
)

export default component.exports